import React from 'react';
import { Box } from '@mui/material';
import { HpLevel, SpotPricePeriod } from '../../../../../core/src/shared/enums';
import { colors } from '../../../theme/palette';

export const ColHeatPumpLevel = ({
  periodIndex,
  pricePeriod = SpotPricePeriod['60M'],
  value,
  tooltip,
}: {
  periodIndex: number;
  pricePeriod?: SpotPricePeriod;
  value: HpLevel;
  tooltip?: string;
}) => {
  let bgcolor = 'grey.200';
  if (value === HpLevel.Increase) {
    bgcolor = 'success.main';
  } else if (value === HpLevel.Normal) {
    bgcolor = colors.brightOrange;
  } else {
    bgcolor = 'error.main';
  }

  return (
    <Box
      sx={{
        gridColumn: pricePeriod === '15M' ? 'span 1' : 'span 4',
        py: 0.5,
      }}
      className={`spot-summary-col-${pricePeriod}-${periodIndex}`}
      data-tooltip={tooltip}
    >
      <Box
        sx={{
          width: 'auto',
          height: { xs: 18, sm: 26 },
          bgcolor,
        }}
      />
    </Box>
  );
};
